import {noop} from 'lodash';
import React, {forwardRef, useRef} from 'react';
import {TableToggleAllRowsSelectedProps} from 'react-table';

import {CheckBox} from '../../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';

/**
 * Selection checkbox used in Table.
 */
export const TableSelectionCheckbox = forwardRef<HTMLDivElement, TableToggleAllRowsSelectedProps>(
  (props, ref) => {
    const defaultRef = useRef<HTMLDivElement>(null);
    const resolvedRef = ref || defaultRef;

    return (
      <ChromelessButton onClick={props.onChange} ref={resolvedRef} {...props}>
        <CheckBox isChecked={props.checked} onChange={noop} />
      </ChromelessButton>
    );
  },
);
